import { PoolShape } from "../constants/pool";
import { PoolInfo, PoolMaterial } from "../context/types";

export const calculateSurfaceArea = ({ info }: { info: PoolInfo }) => {
  if (info.shape === PoolShape.RECTANGULAR) {
    let volume = info.length * info.width * info.depth;
    let surfaceAreaTop = info.length * info.width;

    if (info.poolMaterial !== PoolMaterial.CONCRETE) {
      volume = volume * 0.95;
    }

    return { surfaceAreaTop, volume };
  } else if (info.shape === PoolShape.ROUND) {
    let volume = Math.PI * Math.pow(info.diameter / 2, 2) * info.depth;
    let surfaceAreaTop = Math.PI * Math.pow(info.diameter / 2, 2);

    if (info.poolMaterial !== PoolMaterial.CONCRETE) {
      volume = volume * 0.95;
    }

    return { surfaceAreaTop, volume };
  } else if (info.shape === PoolShape.SQUARE) {
    let volume = Math.pow(info.length, 2) * info.depth;
    let surfaceAreaTop = Math.pow(info.length, 2);

    if (info.poolMaterial !== PoolMaterial.CONCRETE) {
      volume = volume * 0.95;
    }

    return { surfaceAreaTop, volume };
  } else if (info.shape === PoolShape.KIDNEY) {
    let volume = info.surfaceArea * info.depth;
    let surfaceAreaTop = info.surfaceArea;

    if (info.poolMaterial !== PoolMaterial.CONCRETE) {
      volume = volume * 0.95;
    }

    return { surfaceAreaTop, volume };
  } else {
    return { surfaceAreaTop: 0, volume: 0 };
  }
};
